import { render, staticRenderFns } from "./GdprSelectorBox.html?vue&type=template&id=a54c603c&scoped=true&"
import script from "./GdprSelectorBox.ts?vue&type=script&lang=ts&"
export * from "./GdprSelectorBox.ts?vue&type=script&lang=ts&"
import style0 from "./GdprSelectorBox.scss?vue&type=style&index=0&id=a54c603c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54c603c",
  null
  
)

export default component.exports